import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./IndicatorPerson.css";

function IndicatorPerson({
  id,
  firstName,
  lastName,
  profileName,
  profileNameEnglish,
  language,
}) {
  const navigate = useNavigate();

  return (
    <Row className="indicator-person align-items-center">
      <Col className="indicator-person-header">
        <h5 onClick={() => navigate(`/myindicators/person/${id}`)}>
          {firstName} {lastName}
        </h5>
        <p>{language === "es" ? profileName : profileNameEnglish}</p>
      </Col>
    </Row>
  );
}

export default IndicatorPerson;
